module.exports = __webpack_public_path__ + "img/tools4.15f9e635.svg";